import { ComponentProps, useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";

import LoadingIndicator from "../../components/LoadingIndicator/LoadingIndicator";
import config from "../../config";

interface Props {
  delay?: number;
  label?: ComponentProps<typeof LoadingIndicator>["label"];
  size?: ComponentProps<typeof LoadingIndicator>["size"];
}

/**
 * A loading indicator that will show after a delay to avoid flickering for fast requests.
 */
const DelayedLoadingIndicator = ({ delay = config.shared.minLoadingTimeout, label, size }: Props) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  return (
    <AnimatePresence>
      {showLoader && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: config.shared.transitionsDurations.slow }}
        >
          <LoadingIndicator size={size} label={label} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DelayedLoadingIndicator;
